module.exports = "<div class=\"container\">\r\n<div class=\"spacer\">\r\n  <div class=\"recent-view\" [innerHTML]='Description' ng-hide=\"Description === '' || Description === undefined\"></div>\r\n  </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// A:/Work/Siti/Volpe2/src/app/themes/default/html/tnhomedesc.component.html
// module id = ../../../../../src/app/themes/default/html/tnhomedesc.component.html
// module chunks = 1